import React, {FC, ReactNode} from 'react';
import {Router} from 'react-router-dom';
import {BrowserHistory} from "history";
import {trackPageView} from "../utils/analytics/ga";

interface ICustomRouter {
  history: BrowserHistory,
  children: ReactNode,
}

export const CustomRouter: FC<ICustomRouter> = ({children, history}) => {
  const [state, setState] = React.useState({
    action: history.action,
    location: history.location,
  });

  React.useLayoutEffect(() => {
    // Отправляем page_view при первой загрузке
    trackPageView(history.location.pathname + history.location.search);
    
    // Отслеживаем изменения роута и отправляем page_view
    const unlisten = history.listen(({location}) => {
      setState({
        action: history.action,
        location,
      });
      // Отправляем page_view при навигации
      trackPageView(location.pathname + location.search);
    });
    
    return unlisten;
  }, [history]);

  return (
    <Router
      children={children}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
};
